"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR = exports.USER_DATA_FORMAT_MODE = exports.EquipmentStateDisplayMode = exports.SelfRecorderMode = exports.SelfRecorderRangeEnum = exports.UserVersion = exports.UserGroup = exports.EnabledLanguages = void 0;
var EnabledLanguages;
(function (EnabledLanguages) {
    EnabledLanguages["EN"] = "EN";
    EnabledLanguages["RU"] = "RU";
})(EnabledLanguages || (exports.EnabledLanguages = EnabledLanguages = {}));
var UserGroup;
(function (UserGroup) {
    UserGroup[UserGroup["ADMINISTRATOR"] = 0] = "ADMINISTRATOR";
    UserGroup[UserGroup["DIAGNOSTICIAN"] = 1] = "DIAGNOSTICIAN";
    UserGroup[UserGroup["DIRECTOR"] = 2] = "DIRECTOR";
    UserGroup[UserGroup["OPERATOR"] = 3] = "OPERATOR";
    UserGroup[UserGroup["MAINTAINER"] = 4] = "MAINTAINER";
    UserGroup[UserGroup["INSPECTOR"] = 5] = "INSPECTOR";
    UserGroup[UserGroup["STAND_OPERATOR"] = 6] = "STAND_OPERATOR";
    UserGroup[UserGroup["ANALYST"] = 7] = "ANALYST";
    UserGroup[UserGroup["RELIABILITY_ENGINEER"] = 8] = "RELIABILITY_ENGINEER";
    UserGroup[UserGroup["LOCAL_ADMINISTRATOR"] = 9] = "LOCAL_ADMINISTRATOR";
    UserGroup[UserGroup["MECHANIC"] = 10] = "MECHANIC";
    UserGroup[UserGroup["POWER_ENGINEER"] = 11] = "POWER_ENGINEER";
    UserGroup[UserGroup["TECHNICAL_USER"] = 12] = "TECHNICAL_USER";
    UserGroup[UserGroup["TOOL_TECHNICIAN"] = 13] = "TOOL_TECHNICIAN";
})(UserGroup || (exports.UserGroup = UserGroup = {}));
var UserVersion;
(function (UserVersion) {
    UserVersion["BASE"] = "base";
    UserVersion["ADVANCED"] = "advanced";
    UserVersion["PROFESSIONAL"] = "professional";
})(UserVersion || (exports.UserVersion = UserVersion = {}));
var SelfRecorderRangeEnum;
(function (SelfRecorderRangeEnum) {
    SelfRecorderRangeEnum[SelfRecorderRangeEnum["seconds"] = 6] = "seconds";
    SelfRecorderRangeEnum[SelfRecorderRangeEnum["minutes"] = 0] = "minutes";
    SelfRecorderRangeEnum[SelfRecorderRangeEnum["hours"] = 1] = "hours";
    SelfRecorderRangeEnum[SelfRecorderRangeEnum["days"] = 2] = "days";
    SelfRecorderRangeEnum[SelfRecorderRangeEnum["weeks"] = 3] = "weeks";
    SelfRecorderRangeEnum[SelfRecorderRangeEnum["months"] = 4] = "months";
    SelfRecorderRangeEnum[SelfRecorderRangeEnum["years"] = 5] = "years";
})(SelfRecorderRangeEnum || (exports.SelfRecorderRangeEnum = SelfRecorderRangeEnum = {}));
var SelfRecorderMode;
(function (SelfRecorderMode) {
    SelfRecorderMode["INTERVAL"] = "interval";
    SelfRecorderMode["SUBSCRIBE"] = "subscribe";
})(SelfRecorderMode || (exports.SelfRecorderMode = SelfRecorderMode = {}));
var EquipmentStateDisplayMode;
(function (EquipmentStateDisplayMode) {
    EquipmentStateDisplayMode[EquipmentStateDisplayMode["GOST"] = 0] = "GOST";
    EquipmentStateDisplayMode[EquipmentStateDisplayMode["TCI"] = 1] = "TCI";
    EquipmentStateDisplayMode[EquipmentStateDisplayMode["MODE"] = 2] = "MODE";
})(EquipmentStateDisplayMode || (exports.EquipmentStateDisplayMode = EquipmentStateDisplayMode = {}));
exports.USER_DATA_FORMAT_MODE = {
    FIXED: "fixed",
    FLOATING: "floating",
};
exports.USER_DATA_FORMAT_DECIMAL_SEPARATOR = {
    DOT: "dot",
    COMMA: "comma",
};
//# sourceMappingURL=interfaces.js.map